<template>
  <div class="Tabs">
    <b-tabs card v-model="tabIndex">
      <b-tab :title="lang.tab_SearchedParts" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 0">
        <SearchedPartsTableComponent :lang="lang.SearchedParts"></SearchedPartsTableComponent>

      </b-tab>
      <b-tab :title="lang.tab_CreatedByUser" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 1">
        <PhysicalHandmadePartsTableComponent :lang="lang.CreatedByUser"></PhysicalHandmadePartsTableComponent>
      </b-tab>
      <b-tab :title="lang.tab_UsedMPNs" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 2">
        <UsedMPNsTableComponent :lang="lang.UsedMPNs"></UsedMPNsTableComponent>
      </b-tab>

    </b-tabs>



  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import SearchedPartsTableComponent from "@/components/shared/SearchedPartsTableComponent"
import UsedMPNsTableComponent from "@/components/shared/UsedMPNsTableComponent"
import PhysicalHandmadePartsTableComponent from "@/components/shared/PhysicalHandmadePartsTableComponent"


export default {
  name: "Content",
  components: {
    SearchedPartsTableComponent,
    UsedMPNsTableComponent,
    PhysicalHandmadePartsTableComponent


  },
 props:{
    
    lang: Object
  },
  data () {
    return {
      tabIndex: 0,
      data: {},
      emptyHeight: "250px",
      dataCombobox: {title: "Filter list"},
      id: 1,
      isData: false,
      
    }
  },
  computed: {
    ...mapGetters({

      dataTable: 'dataTableSearched',

    }),
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },
  created() {

    if (this.$route.query.tabIndex == 0) {
      this.tabIndex = 0;
    } else {
      this.getTabIndex();
    }
      
    
    if (Object.keys(this.$route.query).length != 0){

    var value = {searchString: this.$store.getters.searchingObject.searchString, providers: this.$store.getters.searchingObject.providers}

    

    this.$store.dispatch(this.$store.getters.sectionPrefix+'_getSearchedParts', value);
    }else{

    var value = {searchString: this.$store.getters.searchingObject.searchString, providers: this.$store.getters.searchingObject.providers}



    this.$store.dispatch(this.$store.getters.sectionPrefix+'_getSearchedParts', value);

      this.isData = true;
      this.data = this.dataTable
    }




  },
  
  watch: {
    dataTable: function (newVal) {
            
      //console.log(newVal[this.filter.filterId].temp)

      if (newVal['columns'].length > 0){

        this.data = Object.assign({}, this.data, newVal)
        this.isData = true;
      }
      //store.dispatch('handleMyStateChange');
    },
    tabIndex: function (newVal) {
      let obj = {};
      obj[this.$route.path + "__middle"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################
      
      this.$parent.$parent.$parent.switchButtons(newVal);
    },
    
  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__middle"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__middle"];
      } else {
        this.tabIndex = 0;
      }

    },
    setTab(index) {
      
      this.tabIndex = index;
    }
  },
}
</script>

<style scooped>



  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartSearch/Middle/Content/Content.vue